import { z } from 'zod';
import { fullRegionsSchema } from './full-region.schema';
import { regionDetailsSchema } from './region-details.schema';

export const availableRegionsSchema = z.object({
  fullRegions: fullRegionsSchema,
  regionDetails: regionDetailsSchema,
});

export type AvailableRegions = z.infer<typeof availableRegionsSchema>;
